import { render, staticRenderFns } from "./CourseListPage.vue?vue&type=template&id=18946c7c&scoped=true"
import script from "./CourseListPage.vue?vue&type=script&lang=js"
export * from "./CourseListPage.vue?vue&type=script&lang=js"
import style0 from "./CourseListPage.vue?vue&type=style&index=0&id=18946c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18946c7c",
  null
  
)

export default component.exports